export const calcContentPaneHeightEmptyStructure = () => {
  return "calc(100vh - 341px)";
};
